import { render, staticRenderFns } from "./OffersUpdates.vue?vue&type=template&id=71cfd65a&scoped=true&"
import script from "./OffersUpdates.vue?vue&type=script&lang=js&"
export * from "./OffersUpdates.vue?vue&type=script&lang=js&"
import style0 from "./OffersUpdates.vue?vue&type=style&index=0&id=71cfd65a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfd65a",
  null
  
)

export default component.exports